import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Container = styled.div`
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #000;
  margin: 5px;
  font-family: sans-serif;
  height: 24px;
  max-width: 100%; 
  flex-shrink: 1; 
`;

const LabelPart = styled.div`
  background-color: ${props => props.bgColor || "#ccc"};
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 11px;
  border-right: 1px solid #000;
  flex-shrink: 0; 
`;

const TextPart = styled.div`
  background-color: #fff;
  padding: 0 10px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 13px;
  
  /* Gestione del testo quando lo spazio finisce */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; 
  flex-grow: 1;
`;
export default class BoxInfo extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired, 
    text: PropTypes.string.isRequired,  
    color: PropTypes.string,            
  };

  render() {
    const { type, text, color } = this.props;

    return (
      <Container>
        <LabelPart bgColor={color}>
          {type}
        </LabelPart>
        <TextPart>
          {text}
        </TextPart>
      </Container>
    );
  }
}